export default __webpack_public_path__ + "static/media/ensoConnectLogo.1443680c.svg";